import generateCRUDOps from './utils/generateCrud';

const pathPrefix = `/`;

const TagService = {
  // Use actual CRUD operations
  ...generateCRUDOps(pathPrefix, 'tags'),
};

export default TagService;
